import { Link } from "react-router-dom";
import Slider from "react-slick";
import DonateButton from "../Components/DonateButton";

import hero1 from "../Assets/images/home1.png";
import hero2 from "../Assets/images/home2.jpg";
import hero3 from "../Assets/images/home3.png";
import hero4 from "../Assets/images/home4.jpg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const stats = [
  { number: "500+", label: "Families Helped" },
  { number: "₹10L+", label: "Funds Raised" },
  { number: "120+", label: "Medical Emergencies" },
  { number: "300+", label: "Active Donors" },
];

const Home = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1200,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    pauseOnHover: false,
  };

  const slides = [hero1, hero2, hero3, hero4];

  return (
    <div className="home-page">

      {/* ── HERO ── */}
      <section className="hero-slider">
        <Slider {...settings}>
          {slides.map((img, i) => (
            <div className="hero-slide" key={i}>
              <img src={img} alt="Foundation Work" />
              <div className="hero-overlay" />
            </div>
          ))}
        </Slider>

        {/* Static content sits above slider, not inside each slide */}
        <div className="hero-content">
          <div className="container">
            <span className="hero-eyebrow">Geetha Alagappan Foundation</span>
            <h1 className="hero-title">
              Together We Can<br /><em>Save Lives</em>
            </h1>
            <p className="hero-sub">
              Supporting medical emergencies, elder care, child care and
              families in need across Tamil Nadu. Even a small help can
              create a big impact.
            </p>
            <div className="hero-actions">
              <DonateButton
                className="hero-btn-primary"
                label="Donate Now"
                redirectAfterLogin="/donate"
              />
              <DonateButton
                className="hero-btn-ghost"
                label="Need Help"
                redirectAfterLogin="/request"
              />
            </div>
          </div>
        </div>

        {/* Scroll hint */}
        <div className="hero-scroll-hint">
          <span />
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map(({ number, label }) => (
              <div className="stat-item" key={label}>
                <strong>{number}</strong>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ABOUT PREVIEW ── */}
      <section className="about-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-image-wrap">
              <img
                src="https://images.unsplash.com/photo-1509099836639-18ba1795216d"
                alt="Charity Work"
              />
              <div className="about-image-badge">
                <strong>Since</strong>
                <span>2018</span>
              </div>
            </div>
            <div className="about-text">
              <p className="section-eyebrow">Who We Are</p>
              <h2>A Foundation Built on <span>Compassion</span></h2>
              <p>
                Geetha Alagappan Foundation is a non-profit trust working to
                support people during the most difficult moments of their lives.
                We focus on emergency medical help, accident relief, elder care,
                child care and livelihood support.
              </p>
              <Link to="/about" className="btn-outline-green">
                Learn More →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHAT WE DO ── */}
      <section className="pillars-section">
        <div className="container">
          <div className="section-header">
            <p className="section-eyebrow">Our Focus Areas</p>
            <h2>Where Your Support Goes</h2>
          </div>
          <div className="pillars-grid">
            {[
              { icon: "🏥", title: "Medical Aid", desc: "Emergency funding for surgeries, treatments and hospitalisation." },
              { icon: "👴", title: "Elder Care", desc: "Support and dignity for the elderly who have no one to rely on." },
              { icon: "👶", title: "Child Care", desc: "Education, nutrition and welfare for underprivileged children." },
              { icon: "🚑", title: "Accident Relief", desc: "Immediate financial help for accident victims and their families." },
            ].map(({ icon, title, desc }) => (
              <div className="pillar-card" key={title}>
                <span className="pillar-icon">{icon}</span>
                <h4>{title}</h4>
                <p>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-inner">
            <p className="section-eyebrow light">Make a Difference</p>
            <h2>Your Small Help Can Change<br />Someone's Life</h2>
            <p>Support a family in need, or raise a fund if you are facing a medical or emergency situation.</p>
            <div className="cta-actions">
              <DonateButton
                className="cta-btn-light"
                label="Donate Now"
                redirectAfterLogin="/donate"
              />
              <DonateButton
                className="cta-btn-outline"
                label="Raise a Fund"
                redirectAfterLogin="/request"
              />
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;